export default "__VITE_ASSET__rVbgALo9__"